<template>
  <v-container fluid>
    <v-app-bar
      :id="id"
      :color="backgroundColor"
      flat
      @click="openContent()"
    >
      <v-app-bar-nav-icon>
        <v-icon :color="siteInfo.colorInfo.iconColor">{{ icon }}</v-icon>
      </v-app-bar-nav-icon>

      <div class="v-app-bar-content-div">
          <v-toolbar-title class="v-toolbar-primary-title" :style="`color: ${textColor}`">
              {{ title }}
          </v-toolbar-title>

          <v-toolbar-title class="v-toolbar-secondary-title" :style="`color: ${textColor}`">
              {{ toolbarTitle }}
          </v-toolbar-title>
      </div>
    </v-app-bar>
    <v-main>
      <div v-show="opened">
        <component
          v-bind:is="name"
          v-bind:resetData="resetData"
          v-bind:formModel="formModel"
          v-bind:selected="selected"
          v-on:childToParent="onChildSelect"
        ></component>
      </div>
    </v-main>
  </v-container>
</template>

<style scoped>
    .clickableAppBar {
        cursor: pointer;
    }
    >>> .v-toolbar__content, .v-app-bar {
        height: fit-content !important;
    }
    .v-app-bar-content-div {
        width: 100%;
    }
    .v-app-bar-content-div > div {
        white-space: normal;
        display: inline-flex;
    }
    .v-toolbar-primary-title {
        margin-right: 15px;
    }
    .v-toolbar-secondary-title {
        float: right;
    }
</style>

<script>
    /* eslint-disable */
    import { mapState, mapActions } from "vuex";
    import FollowUpProcedure from "./FollowUpProcedure";
    import Appointment from "./Appointment";
    import TherapeutsList from "./TherapistsList";
    import Location from "./Location";
    import TimeSlots from "./TimeSlots";
    import ContactForm from "./Contact-form";
    import Category from "./Category";

    export default {
        props: {
            id: Number,
            title: String,
            name: String,
            icon: String,
            opened: Boolean,
            clickable: Boolean, //Can open and close the bar
            resetData: Boolean,
            selected: Boolean,
            formModel: Object,
        },
        data: () => ({
            backgroundColor: "#EFEFEF",
            textColor: "black--text",
            toolbarTitle: null,
        }),
        computed: {
            ...mapState("app", ["status", "siteInfo"]),
            ...mapState({
                appBar: (state) => state.appBar,
            }),
            getFormModel() {
                return this.appBar.formModel;
            },
        },
        mounted: function () {
            this.setCursor();
            this.changeColor();
        },
        components: {
            followupprocedure: FollowUpProcedure,
            "appointment-type": Appointment,
            "contact-form": ContactForm,
            location: Location,
            "time-slots": TimeSlots,
            "therapists-list": TherapeutsList,
            category: Category
        },
        methods: {
            ...mapActions({
                selectComp: "appBar/selectComp",
            }),
            setCursor() {
                var element = document.getElementById(this.id);
                if (this.clickable == true) {
                    element.classList.add("clickableAppBar");
                } else if (this.clickable == false) {
                    element.classList.remove("clickableAppBar");
                }
            },
            changeColor() {
                if (this.opened) {
                    this.backgroundColor = this.siteInfo.colorInfo.sectionSelectedBackgroundColor;
                    this.textColor = `${this.siteInfo.colorInfo.sectionSelectedColor}`;
                } else {
                    (this.backgroundColor = this.siteInfo.colorInfo.sectionBackgroundColor),
                        (this.textColor = "#000");
                }
            },
            openContent() { //Called when clicking on a bar
                if (this.clickable) {
                    this.selectComp({ id: this.id, type: "navigate" });
                }
            },
            onChildSelect(value) {
                var model = this.formModel;
                model = { ...model, ...value };

                this.$emit("childToParent", model);
                this.toolbarTitle = model.title;
            },
        },
        watch: {
            // eslint-disable-next-line no-unused-vars
            opened(value) {
                this.changeColor();
            },
            // eslint-disable-next-line no-unused-vars
            clickable(value) {
                this.setCursor();
            },
            getFormModel(value) {
                if (this.id == value.id) {
                    this.toolbarTitle = value.title;
                }
            },
            // resetData(value) {
            //   if (value) {
            //     this.toolbarTitle = "";
            //   }
            // }
        },
    };
</script>